import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';
import { map, Observable } from 'rxjs';

@Pipe({
    name: 'orderByDescription',
    standalone: false
})
export class OrderByDescriptionPipe implements PipeTransform {
  transform(value: any, sortBy: string, order?: 'asc' | 'desc'): any[] | Observable<any[]> {
    if (Array.isArray(value)) {
      return orderBy(value, [sortBy], [order]);
    } else if (value instanceof Observable) {
      return value.pipe(
        map(data => orderBy(data, [sortBy], [order]))
      );
    } else if (value === null || value === undefined) {
      return [];
    }
    
    return [value];
  }
}

// No need to add asyc | on html

// Pipe can now handle both synchronous arrays and asynchronous Observables without explicitly checking for them.
